exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gameIndex[data-v-1f272f04] {\n  width: 100%;\n  min-height: 100%;\n  background: url(https://static.soyoung.com/sy-pre/back_op-1596107400733.png) #FF8F8F;\n  background-size: 100%;\n}\n.gameIndex .content .logo[data-v-1f272f04] {\n  top: 0.45rem;\n  left: 0.45rem;\n  width: 1.5rem;\n}\n.gameIndex .content .head[data-v-1f272f04] {\n  padding-top: 3rem;\n  margin: 0 auto 2.35rem auto;\n  width: 14.8rem;\n  display: block;\n}\n.gameIndex .content .start[data-v-1f272f04] {\n  width: 9.15rem;\n  display: block;\n  margin: 3.5rem auto 0;\n}", ""]);

// exports
